module.exports = __webpack_public_path__ + "media/images/e-bilet/about/saleofgoods-fa4cb1a48941a022ec1ce0280eed79d5.svg";